import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { newportOrConfig } from "./data";

export default function NewportOrPage() {
  return <OregonCityPageTemplate config={newportOrConfig} />;
}